import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Row from '@prism/row';
import CellFactory from '../utils/cellFactory';

import cellUtils from '../utils/cellUtils';

import { COLUMN_PROP_TYPES } from '../constants';
import { DATA_FORMAT_TYPES } from '../../../../constants';

class PrismGridRow extends React.Component {
    static propTypes = {
        index: PropTypes.number.isRequired,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        data: PropTypes.object.isRequired,
        columns: PropTypes.arrayOf(COLUMN_PROP_TYPES).isRequired,
        selected: PropTypes.bool,
        onChangeSelection: PropTypes.func
    };

    static defaultProps = {
        className: '',
        onChangeSelection: () => { }
    };

    getClassName = (data) => {
        const { className } = this.props;

        if (!data || !className) {
            return;
        }

        return typeof(className) === 'function'
            ? className(data)
            : className;
    }

    handleChangeSelection = () => {
        this.props.onChangeSelection(this.props.data);
    }

    renderContent = ({
        index,
        columns,
        data,
        selected
    }) => (
        <>
            {columns.map((column, colIndex) => {
                if (!column || column.isHidden) {
                    return;
                }

                // TODO: config columns should be mapped to GridPrismColumn component in the root component
                // all data manipulation should be done in the root component with memoize call
                let value = data[column.dataField];
                if (column.render) {
                    value =  column.render(column.withRowData ? data : value);
                }
                let dataFormatProps = cellUtils.getCellExtraProps(data, column.dataFormatProps);
                if (column.dataFormat === DATA_FORMAT_TYPES.SELECT) {
                    value = selected;
                    dataFormatProps = {
                        ...dataFormatProps,
                        onChange: this.handleChangeSelection
                    };
                }

                return (
                    <React.Fragment key={`row_${index}-column_${colIndex}`}>
                        {CellFactory.createCell({
                            value,
                            className: cellUtils.getCellClassName(data, column.className),
                            headerName: column.name,
                            dataFormat: column.dataFormat,
                            cellExtraProps: dataFormatProps,
                            cellColProps: {
                                md: column.md,
                                lg: column.lg,
                                xl: column.xl
                            }
                        })}
                    </React.Fragment>
                );
            })}
        </>
    )

    render() {
        const rowClassName = classNames(
            'prism-grid__body-row',
            this.getClassName(this.props.data)
        );

        return (
            <Row className={rowClassName}>
                {this.renderContent(this.props)}
            </Row>
        );
    }
}

export default PrismGridRow;
